import { history, store } from 'Store';
import { hideModalAction } from 'Store/modules/app/actions';
import { routes } from 'Constants/routes';
import { removeOverflow } from 'Styles/utils/utils';

export const info = {
  title: 'Dg.calculate.notification.title',
  description: 'Dg.modal.notification.description',
  buttonClick: (): void => {
    history.push(routes.DATAGATHERING_HELP);
    removeOverflow();
    store.dispatch(hideModalAction());
  },
  buttonLabel: 'Dg.firstStep.notification.button',
};

export const E_FIRMA =
  'https://www.siat.sat.gob.mx/PTSC/auth/faces/pages/restablecer/recuperarContrasenia.jsf';

export const RECOVER_PASSWORD = 'https://satid.sat.gob.mx/';

export const VIDEO_LINK = 'https://www.youtube.com/embed/ehWMu4_slBI?fs=1';
